import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspMediaPlanMgmt from './components/DspMediaPlanMgmt';

export default function DspMediaPlanPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon DSP Media Plans</h3>
        </Col>
      </Row>
      <Row>
        <DspMediaPlanMgmt />
      </Row>
    </Container>
  );
}
